import { formatMoney } from 'accounting';
import * as React from 'react';
import { connect } from 'react-redux';
import { IStore } from '../../../common/type';
import { is } from '../../../util/is';
import { getClassName } from '../../../util/string-util';
import {
  createDiscountedPriceSelector,
  selectAdBasePrice,
  selectAdInfo
} from '../parts/ads-checkout-selector';
import { IAdsInfo } from '../parts/ads-checkout-type';

const AdsCheckoutRecordContainer: React.SFC<IProps> = props => (
  <tr className="ads-checkout--record">
    <td>{props.index + 1}</td>
    <td>{props.info.name}</td>
    <td>{props.info.typeId}</td>
    <td className="align-right">
      <div className={getClassName(!is.Nil(props.discountedPrice) && 'strikethrough')}>
        {props.basePrice}
      </div>
      {!is.Nil(props.discountedPrice) && <div>{props.discountedPrice}</div>}
    </td>
  </tr>
);

interface IParentProps {
  index: number;
}

interface IStoreProps {
  info: IAdsInfo;
  basePrice: string;
  discountedPrice: string | undefined;
}

type IProps = IParentProps & IStoreProps;

// returns a function instead of object for the selector memoization to work,
// for more details, see https://github.com/reduxjs/reselect#sharing-selectors-with-props-across-multiple-component-instances
const createMapStates = () => {
  const selectDiscountedPrice = createDiscountedPriceSelector();

  return (state: IStore, ownProps: IParentProps): IStoreProps => {
    const basePrice = selectAdBasePrice(state, ownProps.index);
    const discountedPrice = selectDiscountedPrice(state, ownProps.index);

    return {
      info: selectAdInfo(state, ownProps.index),
      basePrice: is.Nil(basePrice) ? 'Unknown' : formatMoney(basePrice),
      discountedPrice: is.Nil(discountedPrice) ? undefined : formatMoney(discountedPrice as number)
    };
  };
};

export const AdsCheckoutRecord = connect(createMapStates)(AdsCheckoutRecordContainer);



// WEBPACK FOOTER //
// ./src/modules/ads-checkout/components/AdsCheckoutRecord.tsx